import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Vessel } from 'icreate/common/models/vessel';
import _ from 'lodash';

@Component({
    selector: 'app-bar-label-dialog',
    templateUrl: './bar-label-dialog.component.html',
    styleUrl: './bar-label-dialog.component.css',
    standalone: false,
})
export class BarLabelDialogComponent {
    vessel: Vessel;
    titleTooLong: boolean = false;
    barLabel: string;
    initialBarLabel: string;
    maxLabelLength: number;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            barLabel: string;
            rowIndex: number;
            channelTitle: string;
            maxBarLabelLength: number;
        },
        private dialogRef: MatDialogRef<BarLabelDialogComponent>
    ) {}

    ngOnInit(): void {
        this.barLabel = this.data.barLabel || '';
        this.initialBarLabel = this.barLabel;
        this.maxLabelLength = this.data.maxBarLabelLength || 16;
    }

    saveLabel() {
        this.dialogRef.close(this.barLabel);
    }

    onBarLabelInput(event: Event) {
        const inputElement = event.target as HTMLInputElement;
        this.barLabel = inputElement.value;
        this.titleTooLong = this.barLabel.length > this.maxLabelLength;
    }

    isSaveDisabled() {
        return (
            this.dialogHasErrors() ||
            !this.data.channelTitle ||
            this.barLabel.length == 0 ||
            this.initialBarLabel === this.barLabel
        );
    }

    dialogHasErrors(): boolean {
        return this.barLabel.length > this.maxLabelLength;
    }

    cancel() {
        this.dialogRef.close();
    }

    removeLabel() {
        this.dialogRef.close(null);
    }

    isRemoveDisabled() {
        return !this.data.barLabel;
    }
}
